export default __webpack_public_path__ + "static/media/play-outline-24px.1b7bf0f8.svg";